<template>
	<div>
		<div id="myChart" :style="{ height: '550px' }" v-loading="loading" :element-loading-text="loadingText"></div>
	</div>
</template>

<script>
	import { getColorInfoOfOrdId } from '@/service/reportService'
	import { $in, like } from '@/network/util/QueryBuilder'
	import { defectStatisRequest } from '@/network/requests/defectStatis'
	import jtService from '@/service/jtService'
	export default {
		components: {},
		props: {
			jt_id: {
				type: String,
			},
			jt_status: {
				type: Object,
			},
		},
		data() {
			return {
				jt_name: '',
				work_shopName: '',
				total_len: '...',
				work_order_code: '',
				loading: false,
				loadingText: '',
				chart: null,
				option: {
					color: ['#e43c59', '#53c100', '#4eaddf', '#fdb86b', '#b400ff', '#2f4554', '#61a0a8'],
					title: { text: '良率-颜色参数', subtext: '统计图', left: 'center' },
					grid: {
						top: 80,
						left: 0,
						right: 0,
						bottom: 50,
						containLabel: true,
					},
					toolbox: { feature: { dataZoom: { yAxisIndex: 'none' }, restore: {}, saveAsImage: {} } },
					tooltip: { trigger: 'axis', axisPointer: { type: 'cross', animation: false, label: { backgroundColor: '#505765' } } },
					legend: { data: [], left: 0 },
					dataZoom: [
						{
							show: true,
							realtime: true,
							start: 65,
							end: 85,
						},
						{
							type: 'inside',
							realtime: true,
							start: 65,
							end: 85,
						},
					],
					xAxis: [
						{
							type: 'category',
							boundaryGap: false,
							axisLine: { onZero: false },
							data: [],
						},
					],
					yAxis: [
						{
							name: '良率',
							type: 'value',
							min: 0,
							max: 1,
							interval: 0.1,
							axisLabel: {
								formatter: function(val) {
									return val * 100 + '%'
								},
							},
							axisPointer: {
								label: {
									formatter: function(params) {
										return (params.value * 100).toFixed(2) + '%'
									},
								},
							},
						},
						{
							name: '颜色值',
							type: 'value',
							min: 0,
							max: 30,
						},
					],
					series: [],
				},
			}
		},
		watch: {
			jt_id(val) {
				this.loading = true
				this.loadingText = '数据加载中...'
				this.getData()
			},
		},
		methods: {
			statCallback(text) {
				this.loadingText = text
			},
			chartTableToData(data) {
				var reuslt = []
				var properties = []
				var meters = []
				data.forEach(t => {
					for (var p in t) {
						if (p in properties == false) {
							properties.push(p)
						}
					}
				})

				properties = [...new Set(properties)]

				//data.forEach(t => {})
				var rates = []
				var legendData = []
				var series = []
				properties.forEach(p => {
					var values = data.map(t => t[p])

					if (p == '米数') {
						meters = values
					} else {
						var yIndex = 1
						console.log(p)
						if (p == '良率') {
							yIndex = 0
						}

						var item = {
							name: p,
							type: 'line',
							animation: false,
							smooth: true,
							yAxisIndex: yIndex,
							lineStyle: { width: 1 },
							data: values,
						}
						if (p == '阈值2') {
							item.smooth = false //关键点，为true是不支持虚线的，实线就用true
							item.itemStyle = {
								normal: {
									lineStyle: {
										width: 1,
										type: 'dotted', //'dotted'虚线 'solid'实线
									},
								},
							}
						}

						series.push(item)

						legendData.push(p)
					}
				})

				this.option.legend.data = legendData
				this.option.xAxis[0].data = meters
				this.option.series = series

				// 绘制图表
				this.chart.setOption(this.option)
			},
			async getData() {
				//通过机台状态中的批次Id获取批次信息。
				var defectStatis = {}
				try {
					defectStatis = await (await defectStatisRequest.getDocumentById(this.jt_status.roll_id)).data
				} catch (error) {
					this.$message.error('批次记录不存在，无法统计。')
				}

				//获取工单Id。
				var job_order_id = defectStatis.job_order_id

				//查询批次的工艺统计信息。
				getColorInfoOfOrdId(job_order_id, this.statCallback)
					.then(res => {
						console.log('工艺参数统计', res)
						this.chartTableToData(res.chartData.rows)

						//工单总长度，由工单批次长度的和构成。
						this.total_len = res.totalLen / 1000
					})
					.catch(err => {
						this.$message.error('批次工艺信息数据查询出错：' + err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
		},
		mounted() {
			// 基于准备好的dom，初始化echarts实例
			this.chart = this.$echarts.init(document.getElementById('myChart'))

			window.addEventListener('resize', () => {
				this.chart.resize()
			})
		},
		async created() {
			this.loading = true
			await this.getData()
		},
	}
</script>

<style></style>
